module.exports = __webpack_public_path__ + "static/brand-burlemarx-white.94aa3932.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/brand/brand-burlemarx-white.svg
// module id = 638
// module chunks = 114276838955818